(function() {
  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // Your logic here
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      // Your logic here
    }
  });

  document.addEventListener('theme:cart:init', (e) => {
    // Your logic here
  });

  document.addEventListener('theme:scroll', () => {});
  document.addEventListener('theme:scroll:up', () => {});
  document.addEventListener('theme:scroll:down', () => {});
  document.addEventListener('theme:resize', () => {});
})();
 
